module.exports = __webpack_public_path__ + "img/slider.e690c74a.png";